<template>
  <div class="place-order">
    <div class="bg-white text-center py-3 shadow border-bottom">
      <router-link to="">
        <logo height="60" />
      </router-link>
    </div>
    <div class="container mt-3">
      <router-link :to="{ name: 'home' }" class="btn btn-primary"
        ><i class="fal fa-arrow-left"></i>Go To Dashboard</router-link
      >
      <div class="row mt-3 justify-content-center">
        <div class="col-9">
          <div class="card">
            <div class="card-body">
              <h1>Order Received #{{ $route.params.id }}</h1>
              <hr>
              <p>Thank you for placing an order with us! We're thrilled to assist with your article and look forward to delivering high-quality content that meets your needs. If you have any additional details or questions, feel free to reach out.</p>
              <router-link :to="{ name: 'orders.show', params: { id: $route.params.id }}" class="btn btn-primary"><i class="fal fa-link"></i> View Order</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer bg-white position-absolute bottom-0 w-100">
      <div class="container-fluid">
        <div class="row text-muted">
          <div class="col-8 text-start">
            <ul class="list-inline">
              <li class="list-inline-item">
                <a class="text-muted" href="#">Support</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Privacy</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Terms of Service</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Contact</a>
              </li>
            </ul>
          </div>
          <div class="col-4 text-end">
            <p class="mb-0">
              &copy; 2024 -
              <a class="text-muted" href="#">SEOVINES</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.$storage.has("token")) {
      return this.$router.push({ name: "login" });
    }

    
  },

  data() {
    return {
      
    };
  },

  methods: {
    
  },

  computed: {
    
  },
};
</script>
